import history from 'utils/history';

import configureStore from './configureStore';

const initialState = undefined;
export const { store } = configureStore(initialState, history);
